export default "__VITE_ASSET__n$kRTIDw__"